module.exports = __webpack_public_path__ + "img/workstream.f0c2fc37.png";